// Import model
import { OtgUomRate } from '../models/OtgUomRate';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgUomRate - handles JSON serialization and deserialization with type validation
 */
export class OtgUomRateSerializer {
  /**
   * Deserializes a JSON string into a OtgUomRate instance
   */
  static deserialize(json: string): OtgUomRate {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgUomRate instance
   */
  static fromObject(obj: any): OtgUomRate {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgUomRate');
    }


    const instance: OtgUomRate = {
      container: obj['container'] as string | undefined,
      uom: obj['uom'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgUomRate instances
   */
  static deserializeArray(json: string): OtgUomRate[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgUomRate instance to a JSON string
   */
  static serialize(instance: OtgUomRate): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgUomRate instance to a plain object
   */
  static toObject(instance: OtgUomRate): any {
    return {
      'container': instance.container,
      'uom': instance.uom,
      'quantity': instance.quantity,
    };
  }

  /**
   * Serializes an array of OtgUomRate instances to a JSON string
   */
  static serializeArray(instances: OtgUomRate[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
